/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    this.hubCartObserver?.disconnect();
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    document.body.classList.add('cart-open');
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Override open method to add body class
   */
  open(opener, elementToFocus, callback) {
    document.body.classList.add('cart-open');
    super.open(opener, elementToFocus, callback);
    this.hubCartObserver?.disconnect();
    const closeDuplicateCart = () => {
      if (!this.hasAttribute('open')) return;
      const hubCart = document.querySelector('.kl-hub-route-cart[role="dialog"]');
      const closeButton = hubCart?.querySelector('button[aria-label="Close dialog"]');
      if (closeButton && !hubCart.dataset.hbClosing) {
        hubCart.dataset.hbClosing = 'true';
        closeButton.click();
        this.hubCartClosing = true;
      } else if (!hubCart && this.hubCartClosing) {
        this.hubCartClosing = false;
        trapFocus(this);
      }
    };
    this.hubCartObserver = new MutationObserver(closeDuplicateCart);
    this.hubCartObserver.observe(document.body, {childList: true, subtree: true});
    closeDuplicateCart();
  }

  /**
   * Override close method to remove body class
   */
  close(callback) {
    this.hubCartObserver?.disconnect();
    this.hubCartClosing = false;
    document.body.classList.remove('cart-open');
    super.close(callback);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);
